module.exports = __webpack_public_path__ + "static/media/company-profile-ad5.b4a9aeec.png";